<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">Reset Password</div> 
                    <div class="card-body">
                        <div id="message" class="alert alert-success" role="alert" v-show="msg" >
                            {{msg}}
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click.prevent="msg = ''">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form method="POST" @submit.prevent="submit">
                            <div class="form-group row">
                                <label for="email" class="col-md-4 col-form-label text-md-right">E-Mail Address</label> 
                                <div class="col-md-6">
                                    <input id="email" type="email" name="email" v-model="email" required="required" autocomplete="email" autofocus="autofocus" class="form-control "
                                        :class="{'is-invalid': hasError}" >
                                    <form-error name="email" :errors="errors"></form-error>
                                </div>
                            </div> 
                            <div class="form-group row mb-0">
                                <div class="col-md-6 offset-md-4">
                                    <button type="submit" class="btn btn-primary">
                                        Send Password Reset Link
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormError from "../../Util/FormError";
import AuthService from "../../../services/AuthService";

export default {
    data: function () {
        return {
            msg: '',
            email: '',
            errors: {},
        }
    },

    components: {
        FormError,
    },

    mounted() {
        this.reset();
    },

    methods: {
        submit: function () {
            this.errors = {};

            AuthService.passwordEmail({ email: this.email })
                    .then( ({data}) => this.success(data) )
                    .catch( ({response}) => this.failed(response) );
        },
        success: function (data) {
            this.msg = data.message;
            this.email = '';
        },
        failed: function(response){
            this.password = '';
            this.errors = response.data.errors;
        },  
        reset: function () {
            this.msg = this.email = '';
            this.errors = {};
        }
    },

    computed: {
        hasError: function () {
            return (this.errors['email']);
        }
    }
}
</script>
